import { createContext, useState, useEffect, useCallback } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = useCallback((token) => {
    const decoded = jwtDecode(token);
    const decUser = {
      id: decoded.sub,
      email: decoded.email,
      role: decoded.role,
      exp: decoded.exp,
    };
    localStorage.setItem("jwt", token);
    setUser(decUser);
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    localStorage.removeItem("jwt");
  }, []);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("jwt");

      if (token) {
        try {
          const decUser = jwtDecode(token);

          if (!decUser.sub || !decUser.email || !decUser.role || !decUser.exp) {
            throw new Error("Invalid token structure");
          }
          const now = Date.now() / 1000;

          if (decUser.exp < now) {
            logout();
          } else {
            setUser({
              id: decUser.sub,
              email: decUser.email,
              role: decUser.role,
              exp: decUser.exp,
            });
          }
        } catch (err) {
          console.error("Invalid token:", err);
          logout();
        }
      }

      setLoading(false);
    };

    checkAuth();
  }, [logout]);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
